/**
 * Props partagées pour les composants d'input unifiés.
 * Utilise les design tokens (spacing, border, focus, typography).
 */

export interface BaseInputProps {
  /** Label visible - utilisé pour aria-label si pas d'id */
  label?: string;
  /** ID pour l'association label/input */
  id?: string;
  /** Message(s) d'erreur - affiche l'état erreur */
  errors?: string[];
  /** Texte d'aide sous l'input */
  helpText?: string;
  /** Désactivé */
  disabled?: boolean;
  /** Lecture seule */
  readOnly?: boolean;
  /** Champs requis */
  required?: boolean;
  /** Classes CSS additionnelles pour le conteneur */
  containerClassName?: string;
  /** Classes CSS additionnelles pour l'input */
  className?: string;
}

/** Classes de base pour tous les inputs (design tokens) */
export const inputBaseClasses = [
  'block w-full',
  'px-token-sm py-token-sm',
  'border border-input-token',
  'rounded-token-md',
  'bg-input-token',
  'type-body-text',
  'placeholder:text-muted',
  'transition-all duration-token ease-token',
  'focus:outline-none focus:ring-2 focus:ring-token-focus focus:ring-offset-token-focus',
  'disabled:opacity-60 disabled:cursor-not-allowed',
  'read-only:cursor-default',
].join(' ');

/** Classes pour l'état erreur */
export const inputErrorClasses = [
  '!border-token-danger !bg-token-danger-bg',
  'focus:!ring-token-danger',
].join(' ');
